import { render, staticRenderFns } from "./TestimonialsHeader.vue?vue&type=template&id=26a5c1eb&scoped=true"
var script = {}
import style0 from "./TestimonialsHeader.vue?vue&type=style&index=0&id=26a5c1eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a5c1eb",
  null
  
)

export default component.exports